import set from 'lodash/set';
import {
  PICKUP_FIELDS,
  DEPLOYMENT_STATUSES,
  POSSESSION_STATUSES,
  EXT_STATUSES,
} from './utils';

export const PICKUP_FIELDS_FILTER = 'pickupFieldsFilter';
export const MAINTENANCE = 'maintenanceFilter';
export const HAS_DEFAULT_GPKG = 'hasDefaultGpkgFilter';
export const FLEET = 'fleetFilter';
export const TASK_ASSIGNEES = 'taskAssigneesFilter';
export const PICKUP_REASONS = 'pickupReasonsFilter';
export const PICKUP_ZONES = 'pickupZonesFilter';
export const GEOFENCE_LAYERS = 'geofenceLayersFilter';
export const INSPECT_REASONS = 'inspectReasonsFilter';
export const HARDWARE = 'hardwareFilter';
export const SCOOTER_TYPE = 'scooterTypeFilter';
export const MIN_BATTERY = 'minBatteryFilter';
export const MAX_BATTERY = 'maxBatteryFilter';
export const MIN_SEARCH_ATTEMPTS = 'minSearchAttemptsFilter';
export const MAX_SEARCH_ATTEMPTS = 'maxSearchAttemptsFilter';
export const LAST_PICKUP_BEFORE = 'lastPickupFilterBefore';
export const LAST_PICKUP_AFTER = 'lastPickupFilterAfter';
export const LAST_DEPLOY_BEFORE = 'lastDeployFilterBefore';
export const LAST_DEPLOY_AFTER = 'lastDeployFilterAfter';
export const LAST_TRIP_BEFORE = 'lastTripFilterBefore';
export const LAST_TRIP_AFTER = 'lastTripFilterAfter';
export const LAST_COMMUNICATION_BEFORE = 'lastCommunicationFilterBefore';
export const LAST_COMMUNICATION_AFTER = 'lastCommunicationFilterAfter';
export const LAST_RIDER_SCAN_BEFORE = 'lastRiderScanFilterBefore';
export const LAST_RIDER_SCAN_AFTER = 'lastRiderScanFilterAfter';
export const LAST_REPORTED_NETWORK = 'lastReportedNetworkFilter';
export const LOCATION = 'locationFilter';

export const DEPLOYMENT_FILTERS = 'deploymentFilters';
export const POSSESSION_FILTERS = 'possessionFilters';
export const EXT_STATUS_FILTERS = 'extStatusFilters';

export const FILTERS = {
  [PICKUP_FIELDS_FILTER]: { NAME: PICKUP_FIELDS_FILTER, DEFAULT: PICKUP_FIELDS.ALL_VEHICLES },
  [MAINTENANCE]: { NAME: MAINTENANCE, DEFAULT: '' },
  [HAS_DEFAULT_GPKG]: { NAME: HAS_DEFAULT_GPKG, DEFAULT: '' },
  [MIN_BATTERY]: { NAME: MIN_BATTERY, DEFAULT: 0 },
  [MAX_BATTERY]: { NAME: MAX_BATTERY, DEFAULT: 100 },
  [MIN_SEARCH_ATTEMPTS]: { NAME: MIN_SEARCH_ATTEMPTS, DEFAULT: 0 },
  [MAX_SEARCH_ATTEMPTS]: { NAME: MAX_SEARCH_ATTEMPTS },
  [FLEET]: { NAME: FLEET, DEFAULT: [] },
  [TASK_ASSIGNEES]: { NAME: TASK_ASSIGNEES, DEFAULT: [] },
  [PICKUP_REASONS]: { NAME: PICKUP_REASONS, DEFAULT: [] },
  [PICKUP_ZONES]: { NAME: PICKUP_ZONES, DEFAULT: [] },
  [GEOFENCE_LAYERS]: { NAME: GEOFENCE_LAYERS, DEFAULT: [] },
  [INSPECT_REASONS]: { NAME: INSPECT_REASONS, DEFAULT: [] },
  [HARDWARE]: { NAME: HARDWARE, DEFAULT: [] },
  [SCOOTER_TYPE]: { NAME: SCOOTER_TYPE, DEFAULT: [] },
  [LAST_PICKUP_BEFORE]: { NAME: LAST_PICKUP_BEFORE, DEFAULT: undefined },
  [LAST_PICKUP_AFTER]: { NAME: LAST_PICKUP_AFTER, DEFAULT: undefined },
  [LAST_DEPLOY_BEFORE]: { NAME: LAST_DEPLOY_BEFORE, DEFAULT: undefined },
  [LAST_DEPLOY_AFTER]: { NAME: LAST_DEPLOY_AFTER, DEFAULT: undefined },
  [LAST_TRIP_BEFORE]: { NAME: LAST_TRIP_BEFORE, DEFAULT: undefined },
  [LAST_TRIP_AFTER]: { NAME: LAST_TRIP_AFTER, DEFAULT: undefined },
  [LAST_COMMUNICATION_BEFORE]: { NAME: LAST_COMMUNICATION_BEFORE, DEFAULT: undefined },
  [LAST_COMMUNICATION_AFTER]: { NAME: LAST_COMMUNICATION_AFTER, DEFAULT: undefined },
  [LAST_RIDER_SCAN_BEFORE]: { NAME: LAST_RIDER_SCAN_BEFORE, DEFAULT: undefined },
  [LAST_RIDER_SCAN_AFTER]: { NAME: LAST_RIDER_SCAN_AFTER, DEFAULT: undefined },
  [LAST_REPORTED_NETWORK]: { NAME: LAST_REPORTED_NETWORK, DEFAULT: [] },
  [LOCATION]: { NAME: LOCATION, DEFAULT: '' },
};

export const getAdvancedFilters = () => {
  const filters = Object.entries(FILTERS);
  return filters.reduce((accum, [_, { NAME, DEFAULT }]) => {
    set(accum, NAME, DEFAULT);
    return accum;
  }, {});
};

export const getStatusFilters = () => ({
  [DEPLOYMENT_FILTERS]: DEPLOYMENT_STATUSES,
  [POSSESSION_FILTERS]: POSSESSION_STATUSES,
  [EXT_STATUS_FILTERS]: EXT_STATUSES,
});

export const getAllFilters = () => ({
  ...getStatusFilters(),
  ...getAdvancedFilters(),
});
